import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

/**
 * When account feature lock_contact_edit_for_agents is enabled, agents cannot edit
 * contact name or phone (enforced in API; UI should disable those inputs).
 */
export function useContactProfileIdentityLock() {
  const route = useRoute();
  const getCurrentRole = useMapGetter('getCurrentRole');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const isContactIdentityLockedForCurrentUser = computed(() => {
    const accountId = Number(route.params.accountId);
    if (!accountId) return false;
    if (getCurrentRole.value !== 'agent') return false;

    return Boolean(
      isFeatureEnabledonAccount.value(accountId, 'lock_contact_edit_for_agents')
    );
  });

  return { isContactIdentityLockedForCurrentUser };
}
